import app from "flarum/forum/app";
export function automaticTabId(path) {
  const bytes = new TextEncoder().encode(path);
  return "auto_" + btoa(String.fromCharCode(...bytes)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
export function pathMatches(template, suffix) {
  const pattern = template.split("/").map(segment => {
    if (/^:[\w]+\.\.\.$/.test(segment)) return ".+";
    if (/^:[\w]+$/.test(segment)) return "[^/]+";
    return segment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }).join("/");
  return new RegExp("^" + pattern + "/?$").test(suffix);
}
export function profileTab(path) {
  const match = path.match(/\/u\/[^/]+(\/[^?#]*)?/);
  if (!match) return undefined;
  const suffix = match[1]?.replace(/\/$/, "") || "";
  return app.forum.attribute("profilePrivacyTabs")?.slice().sort((a, b) => Number(a.path.includes(":")) - Number(b.path.includes(":")) || b.path.length - a.path.length).find(tab => pathMatches(tab.path, suffix))?.id;
}
export function isProtectedTab(path) {
  const tab = profileTab(path);
  return !!tab && (app.forum.attribute("profileHiddenTabs") || []).includes(tab);
}